import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { IRecent } from '~src/recents/types/IRecent';
import { IViewUsageInfo } from '~src/spacesPlatform/models/IUsageInfo';
import { INamedItem } from '~src/spacesPlatform/models/resourceParts';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';
import { IView } from '~src/views/ServerApi/types/IView';
import { IWorkbookParent } from '~src/workbook/ServerApi/types/IWorkbook';

import { IViewRecommendation } from '../types/IViewRecommendation';

export interface IGetRecommendedViewsParams extends IGetItemsParams {
}

export interface IGetRecommendedViewsResult extends IGetItemsResult {
  modelId?: string;
  views?: IView[];
  workbooks?: IWorkbookParent[];
  projects?: INamedItem[];
  users?: IUser[];
  maxStats?: IViewUsageInfo;
  favorites?: string[];
  recents?: IRecent[];
  viewMaxStats?: IViewUsageInfo;
  recommendations?: IViewRecommendation[];
}

export class GetRecommendedViewsRequest extends Request<IGetRecommendedViewsParams, IGetRecommendedViewsResult> {
  constructor(params: IGetRecommendedViewsParams) {
    super('getRecommendations', params);
  }
}
